import styled from 'styled-components';

const ListNotificationWrapper = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  width: 400px;
  max-height: 520px;
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  z-index: 1000;

  .notification-data-wrap {
    padding: 0;
  }

  .notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: sticky;
    top: 0;
    background: #0B2A1B;
    border-radius: 12px 12px 0 0;
    z-index: 1;

    .notification-title {
      font-weight: 600;
      font-size: 16px;
      color: #fff;
    }

    .ant-btn-link {
      color: rgba(255, 255, 255, 0.7);
      font-size: 13px;

      &:hover {
        color: #fff;
      }
    }
  }

  .notification-list {
    padding: 8px 0;
    background: #fff;
    /* Scroll the list itself (not the whole popup), so the scrollbar sits
       inside the rows area under the green header — not as a white strip down
       the popup's right edge next to the header. Height = wrapper cap minus
       the ~53px header, box-sizing so padding can't push past the cap. */
    box-sizing: border-box;
    max-height: calc(520px - 53px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  .notification-item {
    display: flex;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }

    &:last-child {
      border-bottom: none;
    }

    &.unread {
      background-color: #f0f7ff;
    }
  }

  .notification-icon-wrapper {
    width: 44px;
    height: 44px;
    min-width: 44px;
    border-radius: 50%;
    background: #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;

    &.unread {
      background: #0B2A1B;
    }

    .anticon {
      font-size: 20px;
      color: #666;
    }

    &.unread .anticon {
      color: #fff;
    }
  }

  .notification-content {
    flex: 1;
    min-width: 0;
  }

  .notification-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .notification-item-title {
    margin: 0;
    font-size: 15px;
    font-weight: 400;
    color: #333;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.unread {
      font-weight: 600;
      color: #000;
    }
  }

  .unread-dot {
    width: 8px;
    height: 8px;
    min-width: 8px;
    border-radius: 50%;
    background: #1890ff;
  }

  .notification-subtitle {
    font-size: 14px;
    color: #666;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notification-details {
    font-size: 13px;
    color: #888;
    margin-top: 6px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .notification-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .notification-meta {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .status-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    color: #fff;
    text-transform: capitalize;
  }

  .time-ago {
    font-size: 13px;
    color: #888;
  }

  .indicator-icon {
    font-size: 14px;
    color: #888;
  }

  .notification-actions {
    display: flex;
    gap: 2px;
    opacity: 0;
    transition: opacity 0.2s;

    .ant-btn {
      color: #888;

      &:hover {
        color: #333;
        background: rgba(0, 0, 0, 0.05);
      }
    }

    .dismiss-btn:hover {
      color: #ff4d4f;
    }
  }

  .notification-item:hover .notification-actions {
    opacity: 1;
  }

  .notification-empty {
    padding: 60px 20px;
    text-align: center;
    color: #888;
    background: #fff;
    border-radius: 0 0 12px 12px;

    .anticon {
      color: #ccc;
    }

    h4 {
      margin: 16px 0 8px;
      font-size: 16px;
      color: #333;
    }

    p {
      margin: 0;
      font-size: 14px;
    }
  }

`;

export default ListNotificationWrapper;
